import React, {useCallback, useRef, memo} from 'react';
import {
  ErrorMessage, Field, Formik, Form,
} from 'formik';
import * as Yup from 'yup';
import {Link} from 'react-router-dom';
import {ArrowForwardIcon} from '../../components/SvgComponents/SvgComponents';
import Footer from '../../components/Footer/Footer';
import {ROUTES} from '../../configs/routes';
import {t} from '../../services/i18nHandler';
import URL_MAP from '../../constants/urls';
import CommonAPI from '../../api/common';
import {NotificationError, NotificationSuccess} from '../../services/notifications';

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Неправильный формат email')
    .max(60, 'Максимальная длина email 60 символов')
    .required('Поле обязательно к заполнению'),
});

function LandingPageEndSection() {
  const formRef = useRef();

  const onSubmit = useCallback(async (values) => {
    await CommonAPI.subscribeToNews(values.email).then(() => {
      formRef.current.resetForm();
      NotificationSuccess('Подписка на рассылку успешно оформлена!');
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {});
  }, []);

  return (
    <div className="section section--end" data-anchor="connect">
      <div className="section--end--content">
        <div className="section--end--top">
          <div className="section--end--top_text">
            {t('mnj.slogan')}
          </div>
        </div>
        <div className="section--end--bottom">
          <div className="section--end--form">
            <div className="section--end--form_title">
              {t('landingPage.joinUs.title')}
            </div>
            <div className="section--end--form_text">
              {t('landingPage.joinUs.text')}
            </div>
            <Formik
              onSubmit={onSubmit}
              initialValues={{email: ''}}
              validationSchema={validationSchema}
              ref={formRef}
            >
              <Form>
                <div className="section--end--form_field">
                  <Field
                    name="email"
                    type="text"
                    className="ui-input"
                    placeholder="E-mail"
                  />
                  <button className="btn btn-base" type="submit">
                    <span className="btn-text">{t('buttons.subscribe')}</span>
                    <ArrowForwardIcon />
                  </button>
                </div>
                <ErrorMessage
                  className="error-text"
                  name="email"
                  component="div"
                />
              </Form>
            </Formik>
          </div>
          <div className="section--end--bottom_container">
            <div className="section--end--contacts">
              <div className="section--end--contacts_section">
                <div className="section--end--contacts_item phone">
                  <a href="tel:88005113912">8 (800) 511-39-12</a>
                </div>
                <div className="section--end--contacts_item phone">
                  <a href="tel:+74951183136">7 (495) 118-31-36</a>
                </div>
              </div>
              <div className="section--end--contacts_section">
                <div className="section--end--contacts_item email">
                  <a href="mailto:info@mynewjob.pro">info@mynewjob.pro</a>
                </div>
              </div>
            </div>
          </div>
          <div className="section--end--bottom_container">
            <div className="section--end--links">
              <ul className="section--end--links_list list-unstyled">
                <li className="section--end--links_list_item">
                  <Link to={ROUTES.CONTACTS.route}>{t('menuLinks.contacts')}</Link>
                </li>
                <li className="section--end--links_list_item">
                  <Link to={ROUTES.TECHNICAL_SUPPORT.route}>{t('menuLinks.support')}</Link>
                </li>
              </ul>
              <ul className="section--end--links_list list-unstyled">
                <li className="section--end--links_list_item">
                  <Link to={ROUTES.TERMS_OF_USE.route}>
                    {t('menuLinks.terms')}
                  </Link>
                </li>
                <li className="section--end--links_list_item">
                  <Link to={ROUTES.SAFE_MNJ.route}>
                    {t('menuLinks.safeMnj')}
                  </Link>
                </li>
              </ul>
              <ul className="section--end--links_list list-unstyled">
                <li className="section--end--links_list_item">
                  <Link
                    to={ROUTES.SOFTWARE_REQUIREMENTS.route}
                  >
                    {t('menuLinks.softwareRequirements')}
                  </Link>
                </li>
                <li className="section--end--links_list_item">
                  <Link to={ROUTES.LEGAL_DOCUMENTS.route}>{t('menuLinks.documents')}</Link>
                </li>
              </ul>
              <ul className="section--end--links_list list-unstyled">
                <li className="section--end--links_list_item">
                  <Link to={ROUTES.PROCESSING_POLICY.route}>{t('menuLinks.policy')}</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <Footer showFooterNav={false} isFull className="only-footer-bottom" />
      </div>
    </div>
  );
}

export default memo(LandingPageEndSection);
